module.exports = __webpack_public_path__ + "dcdbd15f6de44e328dc61e0aefa4415a.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/en/stingray_business.png
// module id = 855
// module chunks = 0